import { useLocale } from 'next-intl'
import { useMemo } from 'react'
import { IMenuItem } from '@/api/restaurants/types/restaurant-types'
import { Locale, toLocalePriceString } from '@/setup/locales'
import { cn } from '@/utils/styles/cn'

interface IRestaurantDetailMenuItemProps {
    menuItem: IMenuItem
    currencySymbol: string
    className?: string
    style?: React.CSSProperties
}

export const RestaurantDetailMenuItem = ({
    menuItem,
    className,
    style,
    currencySymbol,
}: IRestaurantDetailMenuItemProps) => {
    const locale = useLocale()

    const readablePrice = useMemo(
        () =>
            typeof menuItem.price === 'number'
                ? toLocalePriceString({
                      price: menuItem.price,
                      locale: locale as Locale,
                      currencySymbol,
                  })
                : null,
        [menuItem.price, locale, currencySymbol]
    )

    return (
        <div className={cn('flex flex-col gap-y-1 w-full', className)} style={style}>
            <p className="text-[15px] md:text-[18px] font-bold">{menuItem.name}</p>
            {menuItem.description && (
                <p className="text-gray-800 text-[12px] md:text-[14px]">{menuItem.description}</p>
            )}

            {readablePrice && (
                <p className="font-medium text-[12px] md:text-[14px]">{readablePrice}</p>
            )}
        </div>
    )
}
